export default {
  buildUpdate(id, name, active, text) {
    return {
      'data': {
        'attributes': {
          'name': name,
          'active': active,
          'text': text,
        },
        'type': 'message-automations',
        'id': id,
      },
    };
  },
  buildCreate(name, active, text) {
    return {
      'data': {
        'attributes': {
          'name': name,
          'active': active,
          'text': text,
        },
        'type': 'message-automations',
      },
    };
  },
  async fetchAllAutomations(axios, token) {
    return await axios.get('/api/automation/message-automations/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async createAutomation(data, axios, token) {
    return await axios.post('/api/automation/message-automations/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async deleteAutomation(automationId, axios, token) {
    return await axios.delete(`/api/automation/message-automations/${automationId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async updateAutomation(automationId, data, axios, token) {
    return await axios.patch(`/api/automation/message-automations/${automationId}/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
